import { ComponentType, lazy } from 'react'

const RELOAD_KEY = 'chunk-reload-attempted-at'
const RELOAD_WINDOW_MS = 10_000

export function isChunkLoadError(err: unknown): boolean {
  if (!err) return false
  const msg = err instanceof Error ? err.message : String(err)
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(msg)
}

export function reloadOnceForChunkError(): boolean {
  const last = Number(sessionStorage.getItem(RELOAD_KEY) || '0')
  if (Date.now() - last < RELOAD_WINDOW_MS) return false
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  window.location.reload()
  return true
}

export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      return await factory()
    } catch (err) {
      if (isChunkLoadError(err) && reloadOnceForChunkError()) {
        return { default: (() => null) as unknown as T }
      }
      throw err
    }
  })
}
